import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import alphainnlogo from "./../logo/alphainnlogo.bmp";

const ReceiptPrint = ({ onClose, labelData }) => {
    const headerStyle = {
        backgroundColor: '#1D7874',
        color: '#fff',
        padding: '20px',
        textAlign: 'center',
        fontWeight: 'bold',
    };

    const sectionStyle = {
        padding: '20px',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px',
    };

    const thStyle = {
        // border: '1px solid #ddd',
        border: '1px solid #000',
        padding: '8px',
        backgroundColor: '#f4f4f4',
        textAlign: 'center',
    };

    const tdStyle = {
        // border: '1px solid #ddd',
        border: '1px solid #000',
        padding: '8px',
        textAlign: 'center',
    };

    if (!labelData || labelData.length === 0) {
        return null;
    }

    const firstItem = labelData;

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100);
            if (num < 10000) return units[Math.floor(num / 1000)] + ' Thousand ' + convert(num % 1000);
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };


    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    };

    return (
        <div style={{ margin: '10px auto', backgroundColor: '#fff', border: '2px solid black', }}>
            {/* Header Section */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', flexDirection: 'column' }}>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <img
                        src={alphainnlogo}
                        alt="Company Logo"
                        style={{
                            maxHeight: '100px',
                            width: 'auto',
                            height: 'auto',
                            marginBottom: '5px',
                            marginTop: '10px',
                        }}
                    />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <PlaceIcon style={{ color: 'green', width: '30px', height: '30px' }} />
                    <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                        {firstItem.SalePrint.CompanyAddress}
                    </span>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <PhoneIcon style={{ color: 'blue', width: '30px', height: '30px' }} />
                    <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                        {firstItem.SalePrint.CompanyContactNumber}  {firstItem.SalePrint.CompanyEmail}
                    </span>
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                        GST No  : {firstItem.SalePrint.GSTNumber}
                    </span>
                </div>
            </div>

            {/* Billing Details */}
            <div style={sectionStyle} >
                <h2 style={{ margintTop: '-2%' }}>Bill To</h2>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-20px' }}>
                    <div>
                        <p><strong>Name:</strong> {labelData.SalePrint.GuestName}</p>
                        <p><strong>Phone Number:</strong> {labelData.SalePrint.GuestContactNumber}</p>
                        <p><strong>Email:</strong>{labelData.SalePrint.GuestEmail}</p>
                        <p><strong>Address:</strong> {labelData.SalePrint.GuestAddress}</p>
                    </div>
                    <div style={{ marginTop: '-1%' }}>
                        <p><strong>Receipt Number:</strong> {labelData.SalePrint.BillNumber}</p>
                        <p><strong>Receipt Date:</strong> {formatDateForInput(labelData.SalePrint.ReceiptDate)}</p>
                    </div>
                </div>
            </div>

            {/* Payment Details */}
            <div style={{ textAlign: 'center', marginTop: '-2%' }}>
                <h3>
                    INVOICE
                </h3>

            </div>

            <div style={{ textAlign: 'center', marginTop: '7%' }}>
                <h3>
                    {firstItem.SalePrint.ReceiptType} Amount RS. {firstItem.SalePrint.Amount}/- Received Via   {firstItem.SalePrint.PaymentTypeId === 1 ? "CASH" : firstItem.SalePrint.PaymentTypeId === 2 ? "Cheque" : firstItem.SalePrint.PaymentTypeId === 3 ? "UPI" : "Other"}
                    <p>Payment Mode  : {firstItem.SalePrint.PaymentTypeId === 1 ? "CASH" : firstItem.SalePrint.PaymentTypeId === 2 ? "Cheque" : firstItem.SalePrint.PaymentTypeId === 3 ? "UPI" : "Other"}</p>
                </h3>
            </div>

            {firstItem && firstItem && (
                <div>
                    <h3 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}><AmountInWords amount={firstItem.SalePrint.Amount} /></h3>

                </div >
            )}

            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style>

        </div>
    );
};

export default ReceiptPrint;
